// extracted by mini-css-extract-plugin
export var table = "_uf-0";